import Vue from 'vue'

export const __ = function(texto, vars) {
    if (!vars) return texto
    if (texto.indexOf(':') === -1) return texto

    let matches = Array.from(texto.matchAll(/\:\w+/g))
    if (!matches) return texto

    return matches.reduce((texto, matches) => {
        let match = matches[0]
        return texto.replace(match, vars[match.replace(':', '')])
    }, texto)
}

window.__ = __
Vue.prototype.__ = __
